<template>
  <div id="login_page_wrap">
    <div id="login_page">
      <div id="form_wrapper" md-theme="default-dark">

        <a :href="site_url" class="logo_mobile" id="logo"></a>
        <div v-if="is_loading">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
        <div v-if="!is_loading">
        <div>
          <template v-if="false && !isApp">
          <a class="fb_btn" @click="login_fb()">התחבר באמצעות Facebook</a>
          <a class="g_btn" @click="login_g()">התחבר באמצעות Google</a>

          <h2 class="border_title"><span>או עם שם משתמש וסיסמה</span></h2>
          </template>
            <form @submit.prevent="login()" v-if="show_page=='login'">

                <md-field>
                    <label>שם משתמש / מייל</label>
                    <md-input type="email" name="email" v-model="username" :must="true"></md-input>
                </md-field>

                <md-field>
                    <label>סיסמה</label>
                    <md-input type="password" v-model="password" :must="true"></md-input>
                </md-field>
                <!-- <md-checkbox v-model="remember_me" value="1" class="md-primary">Remember me</md-checkbox> -->


              <div style="margin-bottom:15px; text-align:center;"><input type="submit" value="כניסה" class="btn"></div>
              <div v-if="show_resend_verify" class="verify_resend">
                <p>יש לאשר את כתובת המייל לפני ההתחברות.</p>
                <a @click="resendVerifyEmail">שלח שוב מייל אימות</a>
              </div>
              <div class="bottom_links">
                <a class="bottom_link" @click="show_page='forgot'">שכחת סיסמה?</a>
                <span class="bottom_link signup_prompt">
                  משתמש חדש?
                  <a @click="goto('/signup')">הירשם</a>
                </span>
              </div>
              
            </form>

            
            <!-- <form @submit.prevent="signup()" v-if="show_page=='signup'">

              <ul>
                <li>
                    <label>שם פרטי *</label>
                    <input v-model="signupForm.first_name" name="first_name" required>
                </li>

                <li>
                    <label>אי-מייל *</label>
                    <input v-model="signupForm.username" name="email" required>
                </li>

                <li>
                    <label>סיסמא *</label>
                    <input type="password" v-model="signupForm.password" name="password" required>
                </li>

                <li>
                  <label>
                    <input type="checkbox" v-model="accept_terms" required>אני מאשר/ת שקראתי את <a @click="alert(get_word('terms_content'))" class="u">התקנון</a>
                  </label>
                </li>

              </ul>


              
            </form> -->
            

            
            <form @submit.prevent="forgot()" v-if="show_page=='forgot'">

                    <md-field>
                        <label>אי-מייל *</label>
                        <md-input v-model="forgotForm.email" type="email" name="email" :must="true" />
                        <div style="margin-bottom:15px; text-align:center;"><input type="submit" value="שחזור סיסמא" class="btn"></div>

                    </md-field>
              
            </form>
            
            <form @submit.prevent="forgot2()" v-if="show_page=='forgot2'">
              <p class="gap_bottom">ברגעים אלה נשלח אליך מייל עם קוד לשחזור הסיסמה.<br />אנא הזן את הקוד כאן:</p>
                <md-field>
                    <label>קוד *</label>
                    <md-input v-model="forgotForm.code" :must="true"/>
                </md-field>

              <div style="margin-bottom:15px; text-align:center;"><input type="submit" value="המשך" class="btn"></div>
              
            </form>
            
            <form @submit.prevent="forgot3()" v-if="show_page=='forgot3'">
              <p class="gap_bottom">יופי! כעת נשאר רק לבחור את הסיסמה החדשה שלך.</p>
                <md-field>
                    <label>סיסמא חדשה *</label>
                    <md-input v-model="forgotForm.password" type="password" :must="true"/>
                </md-field>
              <div style="margin-bottom:15px; text-align:center;"><input type="submit" value="שינוי סיסמה" class="btn"></div>

            </form>

            
          </div>
        
        </div>
      </div>

  </div>
</div>
</template>

<script>
export default {
  data(){
      return {
        forgotUrl: window.site_url + 'signup/forgotPass',
        FB: {},
        model: {},
        scope: {},

        token: '',
        show_step_b: false,
        is_loading: false,
        username: '',
        password: '',
        remember_me: false,
        show_error: false,
        show_resend_verify: false,
        
        show_page: 'login',

        accept_terms: false,

        signupForm: { 
          first_name: '',
          username: '',
          gender: '',
          password: '',
          birthday: ''
        },
        
        forgotForm: {
          email: '',
          code: '',
          password: ''
        }
      }
  },
  mounted(){
      
    document.querySelector('input').focus()

  },
  methods:{
    login(){
      this.is_loading = true;
      this.show_resend_verify = false;


      const formData = { 
        password: this.password,
        username: this.username 
      };

      this.api({ action: 'login', data: formData}, (data) => {
        
          if (this.isNull(data) || this.isNull(data.data))
          {
              this.is_loading = false;
              this.alert('הפרטים שהזנת אינם נכונים. אנא נסה שנית.');
          }
          else if (data.data.error === 'email_not_verified')
          {
              this.is_loading = false;
              this.show_resend_verify = true;
              this.alert('יש לאשר את כתובת המייל שנשלחה אליך לפני ההתחברות.');
          }
          else if (typeof data.data === 'object' && data.data.error)
          {
              this.is_loading = false;
              this.alert('הפרטים שהזנת אינם נכונים. אנא נסה שנית.');
          }
          else
          {
            localStorage.setItem('user_token', data.data);
            this.$bus.$emit('reload-page');
          }
          
      });

    },

    resendVerifyEmail(){
      if (this.isNull(this.username))
      {
        this.alert('הזן/י את כתובת המייל לפני שליחה חוזרת.');
        return;
      }

      this.api({ action: 'resend_verify_email', data: { email: this.username } }, () => {
        this.alert('אם החשבון ממתין לאימות, נשלח אליך מייל חדש.');
      });
    },

    signup(){
      this.is_loading = true;

      if (!this.accept_terms) return false;

      this.api({ action: 'signup', data: this.signupForm}, (data) => {
        
          if (this.isNull(data) || this.isNull(data.data))
          {
              this.is_loading = false;
              this.show_error = true;
              //alert('Wrong details. Please try again.');
          }
          else
          {
              this.set_user_token(data.data.token);
              if (this.isApp) this.afterLogin();
  //            document.location = document.location.href;
              this.$bus.$emit('reload');
          }
          
      });

    },

    forgot(){
      this.is_loading = true;

      this.api({ 'action': 'forgot_password', data: this.forgotForm}, (data) => {
        
        this.is_loading = false;

        if (data.data === true)
        {
          this.show_page = 'forgot2'
        }
        else
        {
          this.alert('משתמש לא נמצא');
        }
          
      });

    },    

    forgot2(){
      this.is_loading = true;

      this.api({ 'action': 'forgot_password2', data: this.forgotForm}, (data) => {
        
        this.is_loading = false;

        if (data.data === true)
        {
          this.show_page = 'forgot3'
        }
        else
        {
          this.alert('קוד לא תקין');
        }
          
      });

    },  

    forgot3(){
      this.is_loading = true;

      this.api({ 'action': 'forgot_password3', data: this.forgotForm}, (data) => {
        
        this.is_loading = false;

        if (data.data === true)
        {
          alert('הסיסמה עודכנה בהצלחה.');
          this.username = this.forgotForm.email;
          this.password = this.forgotForm.password;
          this.login();
        }
        else
        {
          this.alert('קוד לא תקין');
        }
          
      });

    },

    afterLogin(){
      if (!this.isIOS)
      {
        var self = this;

        window.cordova.plugins.firebase.messaging.requestPermission({forceShow: true}).then(function() {
     
            window.cordova.plugins.firebase.messaging.subscribe("main");
         
            window.cordova.plugins.firebase.messaging.getToken().then(function(token) {
              
              self.api({ 'action': 'user/set_push_token', data: {'token': token}}, function(){
               
              });
            });
        });
      }
    },
    login_fb(){

      if (this.isApp)
      {
        window.login_fb();
      }
      else
      {
        document.location = window.site_url + '/cfacebook/login';
      }
      
    },
    login_g(){
      if (this.isApp)
      {
        window.plugins.googleplus.login(
          {
            'scopes': 'profile email', // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
            'webClientId': '384286902181-3s8v6bbmlgm7ks5srfqg7juq85r7q7kp.apps.googleusercontent.com', // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
            'offline': true // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
          },
          function (obj) {
            alert(JSON.stringify(obj)); // do something useful instead of alerting
          },
          function (msg) {
            alert('error: ' + JSON.stringify(msg));
          }
        );

      } 
      else
      {
        document.location = window.site_url + '/cgoogle/login';
      }
    },

  }
}
</script>

<style lang="scss" scoped>

ul { 
  li { display: block; margin-bottom: 15px;
    label { display: block; font-size: 17px; padding-right: 15px;}
    input:not([type=checkbox]) { width:100%; height: 50px; background: #fff; color:#333; border:none; border-radius: 50px; padding: 0 25px; font-size: 20px; }
    span { display: block; text-align: left; font-size: 15px; padding-left: 15px;}
  }
}

.div label { left: auto; right: 0;}
.div .md-count, .div .md-error, .div .md-helper-text { left: 0;}


#login_page_wrap { min-height: 100vh; display: flex; align-items: center; }
#login_page { width:400px; max-width:80%; margin:0 auto; } 
  #logo { mask: url(../assets/logo.svg); display: block; height: 120px; background: #000; mask-size: contain; mask-repeat: no-repeat; mask-position: center; margin-bottom: 25px; }

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 30px #eee inset !important;
}

.fb_btn, .g_btn { text-align: center; width: 100%; height: 48px; line-height: 48px; border-radius: 6px; display: inline-block; color: #fff !important;   font-size: 16px; padding: 0 15px; padding-left: 41px; margin-bottom: 15px;  }
.fb_btn { background: #30487b /*url(../images/f_ico.png)*/ 10px center no-repeat; }
.g_btn {  background: #f14338 /*url(../images/f_ico.png)*/ 10px center no-repeat; }

.border_title { color: #A2A2A2; font: 23px sans-serif;  margin-top: 30px; text-align: center; position: relative; z-index: 1; margin: 15px 0px;    
  span { background: #fff; padding: 0 15px; }
  &::before { border-top: 2px solid #dfdfdf; content: ""; margin: 0 auto; position: absolute; top: 50%; left: 0; right: 0; bottom: 0; width: 95%; z-index: -1; }
}

.bottom_links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 4px;
  font-size: 15px;
  color: #8e8d8d;

  .bottom_link { cursor: pointer; }

  a {
    color: inherit;
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover { color: #333; text-decoration: underline; }
  }

  .signup_prompt a {
    color: #ff1661;
    font-weight: 600;
    margin-right: 4px;

    &:hover { color: #d91252; }
  }
}

.verify_resend {
  text-align: center;
  margin-bottom: 15px;
  p { color: #666; margin-bottom: 8px; font-size: 14px; }
  a { text-decoration: underline; cursor: pointer; }
}



</style>